import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { ColumnKey_MiddleColumn, defaultColumnWidthUpdate, MiddleColumn_Findings, PanelKey_Spotlight } from '../../../_shared.js';
import { EndEncounterSurvey } from '@app/advisor-shared';
import { ICONS } from '@app/styles';
import { ModuleFE_Inbox } from '../../../modules/module-inbox/ModuleFE_Inbox.js';
import { ModuleFE_Advisor_AdvisorWizard, ModuleFE_EMInterface, ModuleFE_EncounterMetadata, Renderer_Survey } from '@app/advisor-frontend';
import './AdvisorPanel_Spotlight.scss';
import { ModuleFE_Spotlight, spotlightMode_Disposition, spotlightMode_EditFindings, spotLightMode_PhysicianNotes, spotlightMode_ResolveOrder, spotlightMode_Support, spotlightMode_Survey, spotlightMode_Wizard } from '../../../modules/ModuleFE_Spotlight/index.js';
import { Component_DispositionForm } from '../../components/disposition/Component_DispositionForm.js';
import { Component_AdvisorWizard } from '../../components/advisor-wizard/Component_AdvisorWizard/Component_AdvisorWizard.js';
import { ModuleFE_AdvisorBoard } from '../../../_enum/advisor-board/index.js';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { Renderer_Support } from '../../components/support/Renderer_Support.js';
import { DispoTypeToHeader } from './consts.js';
import { Component_ResolveOrder } from '../../components/resolve-order/Component_ResolveOrder.js';
import { Component_EditFindings } from '../../components/edit-findings/Component_EditFindings.js';
import { Component_ReviewSummary } from '../../components/spotlight/Component_ReviewSummary/Component_ReviewSummary.js';
export class AdvisorPanel_Spotlight extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_Spotlight,
    };
    //######################### Life Cycle #########################
    __onSpotlightMode = () => {
        const dataObj = ModuleFE_Spotlight.getSpotlightData();
        //Close Spotlight
        if (!dataObj) {
            // @ts-ignore
            this.state.data = undefined;
            ModuleFE_AdvisorBoard.updateColumnsWidth(defaultColumnWidthUpdate);
            ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, MiddleColumn_Findings);
        }
        //Set data for spotlight
        this.setState({ data: dataObj });
    };
    __onAdvisorBoardUpdated(updates) {
        if (!updates.includes(ColumnKey_MiddleColumn))
            return;
        setTimeout(() => ModuleFE_ScrollBar.updateScrollBar(this.scrollRef), 310);
    }
    componentDidUpdate() {
        const columnState = ModuleFE_Spotlight.getSpotlightColumnState(this.state.data?.mode);
        const columnWidths = ModuleFE_Spotlight.getSpotlightColumnWidth(this.state.data?.mode);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, columnState);
        ModuleFE_AdvisorBoard.updateColumnsWidth(columnWidths);
    }
    //######################### Logic #########################
    getPanelClass() {
        const columnState = ModuleFE_Spotlight.getSpotlightColumnState(this.state.data?.mode);
        const isFloating = this.props.context === 'floating'; // You'll float too...
        return _className(super.getPanelClass(), 'panel__spotlight', this.state.data?.mode, (columnState.find(item => item.panelKey === this.props.panelKey))?.height === 1 && 'full-height', isFloating && 'special-panel', isFloating && 'interactive');
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        const dataObj = this.state.data;
        switch (dataObj?.mode) {
            case spotLightMode_PhysicianNotes:
                return 'Physician Notes';
            case spotlightMode_Disposition: {
                const data = dataObj.data;
                return DispoTypeToHeader[data.dispositionType];
            }
            case spotlightMode_Wizard: {
                const data = dataObj.data;
                const wizard = ModuleFE_Advisor_AdvisorWizard.cache.unique(data.wizardId);
                return wizard?.renderedLabel ?? wizard?.label ?? 'Wizard Not Found';
            }
            case spotlightMode_EditFindings: {
                return 'Edit Findings';
            }
            case spotlightMode_Survey:
                return EndEncounterSurvey.label; // Again per Eitan decision on 4.11 this is a hard coded const
            case spotlightMode_Support:
                return 'Support';
        }
        return;
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                ModuleFE_Inbox.setSelectedInboxItem(undefined);
                ModuleFE_Spotlight.closeSpotlight();
            } });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = () => {
        if (this.state.data?.mode !== spotlightMode_Survey)
            return;
        return EndEncounterSurvey.description;
    };
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        switch (this.state.data?.mode) {
            case spotlightMode_Wizard:
                return this.renderWizard(scrollRef);
            case spotLightMode_PhysicianNotes:
                return this.renderPhysicianNotes();
            case spotlightMode_Disposition:
                return this.renderDisposition(scrollRef);
            case spotlightMode_Survey:
                return this.renderSurvey(scrollRef);
            case spotlightMode_Support:
                return this.renderSupport(scrollRef);
            case spotlightMode_ResolveOrder:
                return this.renderResolveOrder(scrollRef);
            case spotlightMode_EditFindings:
                return this.renderEditFindings(scrollRef);
            default: {
                if (this.state.data)
                    this.logError(`Missing implementation for mode ${this.state.data.mode}`);
                return _jsx(_Fragment, {});
            }
        }
    };
    renderContent = () => _jsx(_Fragment, {});
    renderWizard = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_AdvisorWizard, { wizard: data.wizardId, contextType: data.contextType, contextId: data.contextId, scrollRef: scrollRef }, data.wizardId);
    };
    renderPhysicianNotes = () => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_ReviewSummary, { note: data.note });
    };
    renderDisposition = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_DispositionForm, { scrollRef: scrollRef, protocolId: data.protocolId, physicianNote: data.physicianNote, additionalProtocolIds: data.additionalProtocolIds, dispositionType: data.dispositionType });
    };
    renderSurvey = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        return _jsx(Renderer_Survey, { scrollRef: scrollRef, submitAction: async (payload) => {
                try {
                    await ModuleFE_EMInterface.vv1.advisorUtils.submitSurvey(payload).executeSync();
                    const dispoType = ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData.dispositionDecision;
                    if (!dispoType)
                        return;
                    ModuleFE_Spotlight.openDisposition({ dispositionType: dispoType }); // return to dispo form
                }
                catch (err) {
                    this.logError(err);
                }
            }, survey: EndEncounterSurvey });
    };
    renderSupport = (scrollRef) => {
        return _jsx(Renderer_Support, { scrollRef: scrollRef });
    };
    renderResolveOrder = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_ResolveOrder, { data: data, scrollRef: scrollRef });
    };
    renderEditFindings = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_EditFindings, { findings: data.findings });
    };
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_Spotlight.js.map